import { createContext, useCallback, useContext, useState } from "react";

const AdminAuthContext = createContext(null);

const STORAGE_KEY = "mu_admin_session";

const loadSession = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
};

// Admin session persists in sessionStorage — survives a page refresh but clears
// when the browser tab/window closes, so a shared front-desk machine doesn't
// stay logged in indefinitely.
export const AdminAuthProvider = ({ children }) => {
  const [session, setSession] = useState(() => loadSession());

  const login = useCallback((s) => {
    setSession(s);
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch (_e) { /* ignore */ }
  }, []);

  const logout = useCallback(() => {
    setSession(null);
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (_e) { /* ignore */ }
  }, []);

  return (
    <AdminAuthContext.Provider value={{ session, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
};
